const DEFAULT_SLOT_DURATION_MINUTES = 30;

// A whole chunk must fit, compared exactly rather than to the nearest minute:
// a start whose slot overruns the interval books time the recruiter does not have.
function chunkSlots(start, end, slotDurationMinutes, notBefore) {
  const slots = [];

  if (!start || !end || !start.isValid() || !end.isValid()) return slots;

  const duration = slotDurationMinutes > 0 ? slotDurationMinutes : DEFAULT_SLOT_DURATION_MINUTES;

  let chunkStart = start.clone();

  while (chunkStart.isBefore(end)) {
    const chunkEnd = chunkStart.clone().add(duration, 'minutes');

    // A sub-millisecond duration truncates to no step and would hang the tab.
    if (!chunkEnd.isAfter(chunkStart)) break;

    const fits = chunkEnd.isSameOrBefore(end);
    const hasGone = notBefore ? chunkStart.isBefore(notBefore, 'minute') : false;

    if (fits && !hasGone) {
      slots.push(chunkStart.format('HH:mm'));
    }

    chunkStart = chunkEnd;
  }

  return slots;
}

export default chunkSlots;
export { DEFAULT_SLOT_DURATION_MINUTES };
